var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54492 5H11.5449C12.0949 5 12.5449 4.55 12.5449 4C12.5449 3.45 12.0949 3 11.5449 3H5.54492C4.44492 3 3.54492 3.9 3.54492 5V19C3.54492 20.1 4.44492 21 5.54492 21H11.5449C12.0949 21 12.5449 20.55 12.5449 20C12.5449 19.45 12.0949 19 11.5449 19H5.54492V5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1949 11.65L18.4049 8.86C18.0849 8.54 17.5449 8.76 17.5449 9.21V11H10.5449C9.99492 11 9.54492 11.45 9.54492 12C9.54492 12.55 9.99492 13 10.5449 13H17.5449V14.79C17.5449 15.24 18.0849 15.46 18.3949 15.14L21.1849 12.35C21.3849 12.16 21.3849 11.84 21.1949 11.65Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.01ecdf2f17017ee83b740949fd110b68.svg";
export { ForwardRef as ReactComponent };